export const RecordAccessFragment = gql`
  fragment RecordAccessFragment on RecordAccess {
    id
    user {
      ...UserDataFragment
    }
  }
`
